module.exports = __webpack_public_path__ + "static/media/zone.aa67c4e5.webp";